import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import ListGroup from 'react-bootstrap/ListGroup';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const TFSkeleton = ( { sections, sidebars } ) => {

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    return (
        // <SkeletonTheme
        //     baseColor="#5294e0"
        //     highlightColor="#96c7ff"
        //     borderRadius="0.5rem"
        //     duration={4}
        // >
        <Container fluid className='p-0'>
            <Row className='tf-page-container'>
                <Col className='p-0'>
                    <Container fluid>
                        <Row className='tf-contact-cv-name-container py-2 align-items-center'>
                            <Col className='fs-4' xs='auto'>
                                <Skeleton width={175} />
                            </Col>
                        </Row>
                        <Row className='py-2'>
                            <Col key='contact-cv-field-1' className='col-md-auto'>
                                <Row><Col className='fs-8'><Skeleton width={75} /></Col></Row>
                                <Row><Col className='fs-7 fw-semibold'><Skeleton width={75} /></Col></Row>
                            </Col>
                            <Col key='contact-cv-field-2' className='col-md-auto'>
                                <Row><Col className='fs-8'><Skeleton /></Col></Row>
                                <Row><Col className='fs-7 fw-semibold'><Skeleton /></Col></Row>
                            </Col>
                            <Col key='contact-cv-field-3' className='col-md-auto'>
                                <Row><Col className='fs-8'><Skeleton duration={45} /></Col></Row>
                                <Row><Col className='fs-7 fw-semibold'><Skeleton /></Col></Row>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row>
                <Col className='pe-0' md={8}>
                    <Row className='tf-section-container mt-0 me-2 p-0'>
                        <Col className='p-0'>
                            <Container fluid className='p-0'>
                                <Container fluid className='p-0'>
                                    <Accordion expanded={true}>
                                        <AccordionSummary>
                                            <Row className='align-items-center w-100'>
                                                <Col><Skeleton /></Col>
                                            </Row>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <ListGroup variant='flush'>
                                                <ListGroup.Item className='border-0 py-0'>
                                                    <Row className='align-items-center'>
                                                        <Col>
                                                            <Skeleton />
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item className='border-0 py-0'>
                                                    <Row className='align-items-center'>
                                                        <Col>
                                                            <Skeleton />
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item className='border-0 py-0'>
                                                    <Row className='align-items-center'>
                                                        <Col>
                                                            <Skeleton />
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item className='border-0 py-0'>
                                                    <Row className='align-items-center'>
                                                        <Col>
                                                            <Skeleton />
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                                <ListGroup.Item className='border-0 py-0'>
                                                    <Row className='align-items-center'>
                                                        <Col>
                                                            <Skeleton />
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                            </ListGroup>
                                        </AccordionDetails>
                                    </Accordion>
                                </Container>
                            </Container>
                        </Col>
                    </Row>
                </Col>
                <Col className='ps-0' md={4}>
                    <Container fluid className='p-0'>
                        <Row className='tf-section-container p-0 mt-0'>
                            <Col className='p-0'>
                                <Container fluid className='p-0'>
                                    <Accordion expanded={true}>
                                        <AccordionSummary>
                                            <Row className='align-items-center w-100'>
                                                <Col><Skeleton /></Col>
                                            </Row>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <ListGroup variant='flush'>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col><Skeleton /></Col>
                                                    </Row>
                                                </ListGroup.Item>
                                            </ListGroup>
                                        </AccordionDetails>
                                    </Accordion>
                                </Container>
                            </Col>
                        </Row>
                </Container>
                </Col>
            </Row>
        </Container>
        // </SkeletonTheme>
    )
}
  
export default TFSkeleton;